const PLATFORM_URL_MAP: Record<string, (handle: string) => string> = {
  tiktok: (handle) => `https://tiktok.com/@${encodeURIComponent(handle)}`,
  instagram: (handle) => `https://instagram.com/${encodeURIComponent(handle)}`,
  youtube: (handle) => `https://youtube.com/@${encodeURIComponent(handle)}`,
  twitter: (handle) => `https://x.com/${encodeURIComponent(handle)}`,
  snapchat: (handle) => `https://snapchat.com/add/${encodeURIComponent(handle)}`,
  facebook: (handle) => `https://facebook.com/${encodeURIComponent(handle)}`,
  pinterest: (handle) => `https://pinterest.com/${encodeURIComponent(handle)}`,
  linkedin: (handle) => `https://linkedin.com/in/${encodeURIComponent(handle)}`,
  twitch: (handle) => `https://twitch.tv/${encodeURIComponent(handle)}`,
};

const PLATFORM_LABELS: Record<string, string> = {
  tiktok: "TikTok",
  instagram: "Instagram",
  youtube: "YouTube",
  twitter: "X (Twitter)",
  snapchat: "Snapchat",
  facebook: "Facebook",
  pinterest: "Pinterest",
  linkedin: "LinkedIn",
  twitch: "Twitch",
};

export function getSocialMediaUrl(platform: string, handle: string): string {
  const builder = PLATFORM_URL_MAP[platform.toLowerCase()];
  return builder ? builder(handle) : "";
}

export function getPlatformLabel(platform: string): string {
  return PLATFORM_LABELS[platform.toLowerCase()] ?? platform;
}
